/* Native product forms submit to Shopify; no price simulation or third-party code. */
(() => {
  let cleanup = () => {};
  function initialize() {
    cleanup();
    const hero = document.querySelector('[data-ld-hero]');
    const sticky = document.querySelector('[data-ld-sticky]');
    const offers = document.querySelector('[data-ld-offers]');
    const footer = document.querySelector('.ld-footer');
    const observers = [];
    document.querySelectorAll('[data-ld-offers]').forEach(section => {
      const updateSelection = () => {
        const checked = section.querySelector('input[type="radio"]:checked');
        const selected = checked?.closest('[data-ld-offer]');
        section.querySelectorAll('[data-ld-offer]').forEach(card => card.classList.toggle('is-selected', card === selected));
        const summary = section.querySelector('[data-ld-selection]');
        if (summary && selected) summary.textContent = `Selected: ${selected.dataset.title} · ${selected.dataset.price}`;
      };
      section.onchange = updateSelection;
      updateSelection();
    });
    if (hero && sticky && 'IntersectionObserver' in window) {
      let passedHero = false;
      let offersVisible = false;
      let footerVisible = false;
      const refresh = () => { sticky.hidden = !passedHero || offersVisible || footerVisible; };
      const headerHeight = document.querySelector('#header-group')?.offsetHeight || 0;
      const heroObserver = new IntersectionObserver(([entry]) => {
        passedHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= headerHeight;
        refresh();
      }, { rootMargin: `-${headerHeight}px 0px 0px 0px` });
      heroObserver.observe(hero);
      observers.push(heroObserver);
      for (const [element, update] of [[offers, value => { offersVisible = value; }], [footer, value => { footerVisible = value; }]]) {
        if (!element) continue;
        const observer = new IntersectionObserver(([entry]) => { update(entry.isIntersecting); refresh(); }, { threshold: 0 });
        observer.observe(element);
        observers.push(observer);
      }
    }
    cleanup = () => observers.forEach(observer => observer.disconnect());
  }
  document.addEventListener('click', event => {
    const offerButton = event.target.closest('.ld-offer-form button');
    if (offerButton) {
      const radio = offerButton.closest('[data-ld-offer]')?.querySelector('input[type="radio"]');
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    const link = event.target.closest('.ld-mobile-menu a');
    if (link) link.closest('details').open = false;
    const factsLink = event.target.closest('a[href="#supplement-facts"]');
    if (factsLink) {
      const facts = document.getElementById('supplement-facts');
      if (facts) facts.open = true;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.ld-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
})();
